export const environment = {
    production: true,
    company: 'pe' as const,
    companyName: 'PE',
    logo: 'assets/images/logo/PE.png',
    staging: true,
    baseUrl: 'https://pe-central-sso-staging.pozitivehub.com/',
    apiUrl: 'https://pe-sso.pozitivehub.com/api/',
    waterUrl:'http://157.245.44.23:9090/quotation/add',
    hubconnection: 'https://pe-sso.pozitivehub.com/api/emailVerifaction',
    redirectUrl :'https://pe-sso.pozitivehub.com',
    ssourl: "https://pe-sso.pozitivehub.com",
    authConfig: {
        authority: "https://pe-sso.pozitivehub.com/",
        redirectUrl: "https://pe-central-sso-staging.pozitivehub.com/",
        postLogoutRedirectUri: 'https://pe-central-sso-staging.pozitivehub.com/signout-callback-oidc',
        clientId: "central-spa-stag",
        scope: 'openid profile email roles offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        accounturl:"https://pe-central-account-staging.pozitivehub.com/",
    },
    20: "Water",
    10 : "Elect",
    11 : "Gas",
    30 : "Mobile",
    40 : "Issuing",
    41 : "Acquiring",
    42 : "Lending",
    50: "EVC" ,
    60 : "Partner",
    70: "Tech Tool Kit",
    71: "HR",
    72: "Accounting",
    73: "Rewards",
    74: "Analytics",
    99: "Test"
};
 